var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 569,
    viewBox: "0 0 1920 569",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1048.25 119.968L1047.85 118.765L1126.43 102.707L1130.12 0.404175L1131.74 0.438677L1128 103.668L1048.25 119.968Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.7 165.51L1126.4 103.599L1130.14 0.404176H1130.93L1131.53 -0.0147705L1329.61 164.5L1328.7 165.51ZM1128.03 102.771L1325.98 163.347L1131.69 1.96169L1128.03 102.771Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.902 200.377L84.2752 167.581L286.515 107.025L286.803 107.601L287.526 107.892L224.902 200.377ZM89.2224 167.433L224.109 198.893L285.146 108.779L89.2224 167.433Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.04 200.451L286.125 107.321L286.835 107.601L287.507 107.271L350.79 184.304L223.04 200.451ZM286.906 108.853L225.958 198.819L348.122 183.377L286.906 108.853Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.462 184.511L469.958 88.8916L470.528 89.3204H471.347L473.734 181.219L347.462 184.511ZM469.76 90.8286L351.45 183.166L472.096 180.006L469.76 90.8286Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.712 195.852L472.122 181.145V180.622L469.76 89.35H470.566L471.149 88.931L599.712 195.852ZM473.702 180.08L595.405 194.112L471.379 90.9469L473.702 180.08Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.984 195.507L597.043 194.522L725.043 111.466L801.44 96.8812L802.08 98.0198L597.984 195.507ZM725.76 112.585L606.554 189.967L796.826 99.045L725.76 112.585Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.03 208.948L937.587 179.04L938.035 177.837L1068.95 207.189L1047.25 119.48L1048.83 119.243L1071.03 208.948Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.6 267.774L1069.24 208.396L1069.19 208.199L1047.24 119.48L1048.02 119.367L1048.74 119.071L1149.86 267.025L1148.6 267.774ZM1070.72 207.76L1146.07 264.151L1049.84 123.325L1070.72 207.76Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.44 267.606L1046.86 118.953L1127.9 102.397L1128.01 103.121L1149.95 267.251L1148.44 267.606ZM1049.24 119.741L1147.92 264.156L1126.5 103.969L1049.24 119.741Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.44 267.892L1148.66 266.813L1328.36 164.53L1328.89 163.78L1330.11 165.072L1329.59 165.367L1288.42 222.69L1288.16 222.774L1149.44 267.892ZM1326.47 167.152L1155.08 264.713L1287.3 221.714L1326.47 167.152Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.49 268.464L1126.27 102.229L1330.66 164.761L1148.49 268.464ZM1128.14 104.136L1149.8 266.167L1327.36 165.106L1128.14 104.136Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.97 235.737L1286.61 222.631L1328.9 163.776L1329.75 164.702L1365.97 235.737ZM1289.09 221.763L1363.37 234.036L1328.88 166.388L1289.09 221.763Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.92 235.12L1327.86 164.387L1368.63 161.976L1365.47 234.923L1363.92 235.12ZM1330.16 165.501L1364 231.867L1366.95 163.317L1330.16 165.501Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.94 235.475L1364.28 234.342L1577.39 145.627L1578.16 146.717L1374.28 231.591L1487.96 200.416L1488.49 201.589L1364.94 235.475Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.84 235.949L1367.04 162.08L1367.74 162.026L1577.69 145.539L1578.16 146.702L1363.84 235.949ZM1368.59 163.209L1365.54 233.834L1573.86 147.086L1368.59 163.209Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 245.604V247.802L36.5632 289.052L0 285.237V286.489L39.936 290.654L0 245.604Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 190.697V194.97L35.9552 286.159L0 245.604V247.802L37.5872 290.2L39.0272 289.673L0 190.697Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.768 291.477L85.9264 167.448V167.201L88.2112 165.959L87.5712 167.586L96.3776 257.364L36.768 291.477ZM86.2592 170.853L39.744 288.229L94.72 256.773L86.2592 170.853Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 122.201V123.689L85.8048 167.763L38.2592 287.721L0 190.697V194.97L38.2528 291.979L87.6992 167.24L0 122.201Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.054 307.574L94.7648 257.537L85.9072 167.226L86.7776 166.733L87.2576 167.029L306.778 306.515L306.054 307.574ZM96.288 256.595L302.643 305.465L87.68 168.901L96.288 256.595Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.779 307.461L86.2592 167.975L87.008 166.895L225.056 199.1L306.982 306.667L305.779 307.461ZM90.368 168.995L303.29 304.277L223.962 200.16L90.368 168.995Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.4 314.687L378.81 256.379L348.685 184.033L349.165 183.91L350.01 183.387L523.334 313.701L522.4 314.687ZM380.16 255.516L518.234 311.596L351.194 186.024L380.16 255.516Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.39 316.229L347.52 183.259L473.504 179.972L524.39 316.229ZM351.36 184.403L521.158 312.06L472.32 181.243L351.36 184.403Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.354 314.598L522.074 313.883L597.888 193.033L611.098 245.279L523.354 314.598ZM597.235 196.947L525.658 310.985L609.357 244.865L597.235 196.947Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.586 315.879L471.795 179.844L598.765 194.487L522.586 315.879ZM474.035 181.367L522.97 312.414L596.358 195.473L474.035 181.367Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.298 341.066L609.498 245.412L596.774 195.098L597.6 194.96L598.163 194.566L767.398 340.164L766.298 341.066ZM610.97 244.722L759.91 335.59L598.912 197.09L610.97 244.722Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.36 341.968L596.083 194.64L597.363 194.379L806.694 152.065L767.36 341.968ZM599.04 195.32L766.272 339.203L804.717 153.75L599.04 195.32Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.053 341.174L766.547 339.996L955.699 291.432L937.018 178.518L938.611 178.36L957.459 292.29L767.053 341.174Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.202 178.077L766.208 340.234L767.46 341.017L938.454 178.86L937.202 178.077Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.202 178.077L766.208 340.234L767.46 341.017L938.454 178.86L937.202 178.077Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.08 324.569L955.827 292.275L955.77 291.94L937.018 178.518L937.83 178.434L938.522 178.143L1043.08 324.569ZM957.318 291.447L1039.24 321.779L939.149 181.588L957.318 291.447Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.53 324.978L1040.45 323.499L936.173 177.423L1070.92 207.642L1070.78 208.204L1041.53 324.978ZM939.462 179.459L1040.79 321.37L1069.06 208.5L939.462 179.459Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.27 323.918L1148.54 266.882L1148.69 266.695H1151.8L1149.73 267.759L1108.04 320.991L1038.27 323.918ZM1146.58 269.401L1044.04 322.425L1107.11 319.768L1146.58 269.401Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 324.52L1069.48 206.824L1150.44 267.404L1040 324.52ZM1070.5 209.313L1042.31 321.824L1147.87 267.232L1070.5 209.313Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.42 359.332L1106.41 320.68L1148.69 266.695H1149.56L1149.81 266.961L1233.42 359.332ZM1108.77 320.054L1229.04 356.661L1149.2 268.434L1108.77 320.054Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.5 359.381L1147.92 267.045L1289.17 221.103L1231.5 359.381ZM1150.39 267.592L1230.97 356.611L1286.56 223.296L1150.39 267.592Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.62 358.539L1230.61 357.602L1364.04 234.49L1365.45 234.982L1344.2 310.162L1343.89 310.295L1231.62 358.539ZM1363.2 237.215L1234.64 355.818L1342.8 309.344L1363.2 237.215Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.84 358.396L1230.47 357.804L1287.31 221.472L1366.14 234.494L1231.84 358.396ZM1288.4 222.921L1233.28 355.157L1363.2 235.273L1288.4 222.921Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.8 393.159L1342.58 310.068L1364.23 233.519L1365.28 234.504L1536.8 392.227L1535.8 393.159ZM1344.44 309.442L1532.78 390.428L1365.12 236.229L1344.44 309.442Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.56 394.854L1535.56 393.011L1363.31 234.598L1488.83 200.175L1537.56 394.854ZM1366.04 235.16L1534.81 390.369L1487.61 201.826L1366.04 235.16Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 270.988L1838.64 402.977L1724.25 355.734L1920 253.333V251.829L1721.14 355.857L1838.62 404.372L1839.37 404.687L1920 273.886V270.988Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 384.977L1840.5 402.844L1920 273.886V270.988L1837.5 404.82L1920 386.278V384.977Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1488 289.668L39.3024 289.214L38.5856 289.234L37.8368 288.648L37.6256 289.249L0 289.983V291.225L37.1968 290.501L7.616 376.238L0 369.032V371.004L8.3648 378.909L38.8736 290.466L40.1472 290.437L39.1488 289.668Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 285.237V286.494L28.1728 289.431L0 289.983V291.225L38.2784 290.476L38.368 289.244L0 285.237Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8288 378.54L37.8368 288.648L38.8224 289.412L129.062 346.744L6.8288 378.54ZM38.7072 290.94L9.1584 376.622L125.786 346.276L38.7072 290.94Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.877 348.237L36.9536 289.836L96 256.024L128.877 348.237ZM39.5712 289.88L125.971 344.787L95.0592 258.109L39.5712 289.88Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.318 325.047L304.96 307.067L378.938 255.486L380.218 256.196L341.318 325.047ZM307.61 306.899L340.602 323.223L377.242 258.335L307.61 306.899Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.902 343.446L456.608 343.402L340.768 324.737L340.877 323.509L522.682 313.533L523.046 314.45L523.136 314.687L456.902 343.446ZM346.778 324.456L456.646 342.155L519.238 314.987L346.778 324.456Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.33 389.462L455.04 342.835L522.381 313.612L522.822 314.105L523.462 313.829L578.33 389.462ZM458.509 342.761L574.4 386.598L522.458 314.992L458.509 342.761Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.749 389.837L521.773 314.051L611.501 243.174L576.749 389.837ZM523.763 314.258L575.968 386.219L608.966 246.95L523.763 314.258Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.493 388.644L576.109 387.441L766.554 339.996L767.046 341.174L586.931 386.056L709.293 370.427L709.555 371.654L576.493 388.644Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.36 388.945L609.709 243.938L768.518 340.824L575.36 388.945ZM610.81 246.195L577.395 387.116L765.114 340.356L610.81 246.195Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.491 371.654L709.35 370.412L932.698 355.724L766.707 341.199L766.893 339.972L940.934 355.192L940.922 356.434L709.491 371.654Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.498 356.493L940.755 356.434L766.72 341.214L766.56 340.011L957.626 290.939L941.498 356.493ZM770.522 340.282L940.192 355.133L955.552 292.783L770.522 340.282Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.33 456.504L939.622 355.542L1042.06 322.198L1029.33 456.504ZM942.08 356.094L1028.08 452.867L1040.28 324.135L942.08 356.094Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.782 356.843L955.974 290.939L1043.12 323.194L939.782 356.843ZM957.171 292.768L941.92 354.793L1039.2 323.13L957.171 292.768Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.08 456.849L1039.7 322.607L1108.18 319.719L1108.35 320.212L1157.51 456.346L1156.08 456.849ZM1042.61 323.726L1154.61 452.941L1106.98 321.005L1042.61 323.726Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.2 457.283L1232 355.7V357.878L1275.52 445.045L1155.2 457.283ZM1231.08 359.45L1158.27 455.745L1273.34 444.049L1231.08 359.45Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.48 458.091L1106.37 319.334L1107.87 319.788L1232.4 357.686L1231.92 358.307L1156.48 458.091ZM1108.79 321.405L1157.01 454.922L1230.05 358.317L1108.79 321.405Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.7 444.759L1230.43 358.12V356.577L1231.78 357.538L1333.42 429.898L1332.33 430.81L1233.22 360.259L1275.21 444.31L1273.7 444.759Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.56 431.687L1332.33 430.81L1229.88 357.863L1344.44 308.659L1333.56 431.687ZM1232.6 358.12L1332.19 429.016L1342.59 310.852L1232.6 358.12Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 431.15L1342.78 308.733L1538.37 392.843L1332 431.15ZM1344.22 310.778L1333.75 429.563L1534 392.39L1344.22 310.778Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.84 445.36L1536.64 406.56L1535.36 392.375L1536.14 391.774L1536.7 392.133L1617.78 444.35L1616.84 445.36ZM1538.12 405.841L1607.68 439.45L1537.13 394.011L1538.12 405.841Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.34 446.321L1535.14 392.725L1535.56 392.232L1597.31 322.676L1597.58 324.278L1618.34 446.321ZM1537.28 392.498L1616.22 443.334L1596.24 326.072L1537.28 392.498Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1718.48 455.637L1615.64 445.286L1722.11 355.359L1722.86 355.793H1723.5L1718.48 455.637ZM1618.91 444.374L1716.95 454.232L1721.81 357.479L1618.91 444.374Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.7 446.237L1616.47 444.912L1595.78 323.5L1724.16 355.507L1616.7 446.237ZM1597.72 325.279L1617.84 443.418L1721.27 356.084L1597.72 325.279Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.08 496.068L1716.89 455.385V454.892L1721.89 355.606L1722.53 354.763L1723.27 355.35L1894.08 496.068ZM1718.55 454.469L1888.83 493.574L1723.42 357.287L1718.55 454.469Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.86 495.25L1722.11 356.217L1723.08 355.231L1839.62 403.361L1839.73 403.568L1892.21 494.565L1890.86 495.25ZM1726.62 358.12L1888.78 491.691L1838.37 404.303L1726.62 358.12Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 479.448L1897.64 490.907L1920 473.563V471.808L1890.87 494.382L1891.89 495.343L1920 480.941V479.448Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 471.798L1891.72 493.746L1840.11 404.229L1920 386.278V384.987L1837.89 403.435L1891.19 495.9L1920 473.563V471.798Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 369.032V371.004L7.1296 377.756L0 407.319V414.121L8.8512 377.406L0 369.032Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 441.072V442.807L127.078 347.636L183.437 473.671L0 449.402V450.664L185.85 475.263L128.352 346.685L129.024 346.182L128.038 345.99L127.776 345.388L127.187 345.822L126.182 345.625L126.502 346.35L0 441.072Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 414.121L8.6976 378.057L124.314 347.976L0 441.072V442.807L127.994 346.951L127.174 345.926L7.2896 377.105L0 407.319V414.121Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.95 446.228L340.794 323.007L341.709 323.909L392.435 426.261L258.95 446.228ZM340.87 325.648L261.901 444.517L390.24 425.324L340.87 325.648Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.898 494.55L390.682 426.202L340.211 324.352L340.954 324.125L341.594 323.726L524.986 493.638L523.898 494.55ZM392 425.383L520.192 491.159L343.443 327.413L392 425.383Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.725 494.432L338.861 323.15L457.389 342.259L457.536 342.594L525.107 493.83L523.725 494.432ZM343.04 325.096L522.157 491.05L456.166 343.328L343.04 325.096Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.893 502.056L523.226 494.55L575.75 387.515L576.973 387.274L577.146 387.914L606.893 502.056ZM525.44 493.515L604.851 500.637L576.09 390.28L525.44 493.515Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.314 495.861L455.373 341.588L577.363 387.732L524.314 495.861ZM458.17 344.013L524.384 492.204L575.36 388.343L458.17 344.013Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.094 501.47L575.667 388.516L573.485 387.949L576.973 387.274L577.056 387.564L799.93 445.321L799.418 446.499L577.421 388.969L606.669 501.228L605.094 501.47Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.418 446.499L576.102 388.624L576.23 387.417L709.293 370.427L709.555 371.654L579.68 388.235L799.93 445.321L799.418 446.499Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.186 446.395L799.162 445.429L938.349 356.611L709.491 371.654L709.35 370.412L943.354 355.039L800.186 446.395Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.216 496.595L939.904 353.659L1029.83 454.858L949.216 496.595ZM941.805 357.972L950.688 494.318L1027.58 454.503L941.805 357.972Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.91 519.529L1537.06 405.313L1618.8 444.828L1462.91 519.529ZM1537.7 407.093L1466.88 516.187L1615.74 444.852L1537.7 407.093Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.69 569L1614.66 443.94L1718.2 454.345L1808.89 568.201L1807.69 569ZM1619.9 445.705L1804.92 565.569L1717.24 455.489L1619.9 445.705Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.51 568.857L1715.92 453.867L1891.69 494.224L1891.23 495.417L1719.5 455.982L1808.89 568.206L1807.51 568.857Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 479.448L1891.01 494.298L1891.9 495.343L1920 480.941V479.448Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.282 534.597L390.566 426.537L260.576 445.986L260.275 444.759L392.109 425.048L397.894 534.538L396.282 534.597Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.326 535.479L390.47 424.58L526.08 494.165L396.326 535.479ZM392.211 426.975L397.843 533.636L522.643 493.889L392.211 426.975Z",
    fill: "#E7E5E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 569,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero2);
export default __webpack_public_path__ + "static/media/hero2.e9df86e7351b38ad1177ae5c1943040b.svg";
export { ForwardRef as ReactComponent };